import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';

export const ProductCatalogModal = ({ open, onOpenChange, product, onWhatsAppClick }) => {
  if (!product) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto p-0" data-testid="product-catalog-modal">
        {/* Modal Header */}
        <div className="relative bg-gradient-to-r from-blue-900 via-blue-800 to-green-700 p-8 rounded-t-lg">
          <DialogHeader>
            <p className="text-yellow-300 text-sm font-semibold tracking-wider mb-2">PRODUCT CATALOG</p>
            <DialogTitle className="text-3xl md:text-4xl font-bold text-white" data-testid="modal-category-title">
              {product.name}
            </DialogTitle>
            <DialogDescription className="text-blue-100 text-base mt-2">
              {product.description}
            </DialogDescription>
          </DialogHeader>
        </div>

        {/* Products Grid */}
        <div className="p-6 md:p-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6">
            {product.items?.map((item, idx) => (
              <div 
                key={idx}
                className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-200"
                data-testid={`product-item-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="relative aspect-square overflow-hidden bg-gray-100">
                  <img 
                    src={item.image} 
                    alt={item.name}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="p-4">
                  <h4 className="font-bold text-blue-900 text-base mb-1">{item.name}</h4>
                  <p className="text-xs text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Footer */}
          <div className="mt-8 bg-gradient-to-br from-yellow-50 to-green-50 rounded-xl p-6 md:p-8 text-center">
            <h4 className="text-xl md:text-2xl font-bold text-blue-900 mb-2">
              Interested in {product.name}?
            </h4>
            <p className="text-gray-700 mb-5">
              Contact us for wholesale pricing and bulk orders.
            </p>
            <Button 
              onClick={onWhatsAppClick}
              size="lg"
              className="bg-green-500 hover:bg-green-600 text-white font-semibold px-8 py-6 rounded-full transition-all duration-300 hover:scale-105 shadow-lg"
              data-testid="modal-whatsapp-cta"
            >
              <MessageCircle className="mr-2" size={20} />
              Enquire via WhatsApp
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
